import {DateTime} from "@2d-front-monorepo/core";
import {PriceBreakdown} from "./Price";

interface ParkingOperationStep extends PriceBreakdown {
	endDate: DateTime;
	duration: number;
	default: boolean;
}

function parkingOperationStepFactory(endDate: DateTime): ParkingOperationStep {
	return {
		amount: 0,
		total: 0,
		fee: 0,
		endDate: endDate,
		duration: 0,
		amountPlusVat: 0,
		amountWithoutBonification: 0,
		realAmount: 0,
		bonification: 0,
		vat: 0,
		feePlusVat: 0,
		wallet: 0,
		totalToPay: 0,
		time: 0,
		timeBalanceUsed: 0,
		vatBreakdown: [],
		default: false,
		subtotal: 0
	};
}

export {ParkingOperationStep, parkingOperationStepFactory};
